import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { A2zLibModule, AngularMaterialModule, PipesModule, SocketService, LoadingInterceptor, LoadingModule } from "@school/a2z-lib";

import { AppComponent } from "./app.component";
import { ViewsModule } from "./views/views.module";
import { AppRoutingModule } from "./app-routing.module";
// SVG inline
import { InlineSVGModule } from "ng-inline-svg";
import {
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
} from "ngx-perfect-scrollbar";
import { environment } from "../environments/environment";

import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';

const config: SocketIoConfig = { url: environment.SOCKET_ENDPOINT, options: {} };
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  // suppressScrollX: true,
  wheelSpeed: 0.5,
  swipeEasing: true,
  minScrollbarLength: 40,
  maxScrollbarLength: 300
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgbModule,
    A2zLibModule.configureEnvironment(environment),
    AngularMaterialModule,
    HttpClientModule,
    InlineSVGModule.forRoot(),
    ViewsModule,
    AppRoutingModule,
    PipesModule,
    LoadingModule,
    SocketIoModule.forRoot(config)
  ],
  exports: [
    AngularMaterialModule,
    InlineSVGModule,
    AppRoutingModule,
  ],
  providers: [{
    provide: PERFECT_SCROLLBAR_CONFIG,
    useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
  },{
    provide: HTTP_INTERCEPTORS,
    useClass: LoadingInterceptor,
    multi: true
  },SocketService],
  bootstrap: [AppComponent],
})
export class AppModule { }
